<template>
	<div class="cooperation">
		<div class="container">
			<!-- 轮播图 -->
			<div class="swiper-container">
			    <div class="swiper-wrapper">
					<div class="swiper-slide" v-for="item in navlist">
						<img :src="item.imgUrl" style="width:100%">
						<p style="text-align:center">{{item.title}}</p>
					</div>
			    </div>
			</div>
		    <!-- Add Arrows -->
		    <div class="swiper-button-next"></div>
		    <div class="swiper-button-prev"></div>
		</div>
	</div>
	
</template>

<script>
	import Swiper from "swiper";
	import "swiper/dist/css/swiper.min.css";
	export default{
		name:'',
		components:{},
		data(){
			return{
				msg:"行业新闻",
				navlist:[]
			}
		},
		methods:{
			getList(){
				this.axios({
					method: 'get',
					url: this.GLOBAL.projectGetCooperationApi,
					data: {}
				})
				.then((res) => {
					this.navlist = res.data.data;
				})
				.catch((err) => {
					console.log(err)
				})
			},
		},
		mounted(){
		    var mySwiper = new Swiper('.swiper-container', {
				slidesPerView: 5,
				spaceBetween: 20,
				slidesPerGroup: 3,
				loop: false,
				loopFillGroupWithBlank: true,
				observer:true,//修改swiper自己或子元素时，自动初始化swiper 
				observeParents:false,//修改swiper的父元素时，自动初始化swiper 
				onSlideChangeEnd: function(swiper){ 
					swiper.update(); 
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
		    });
 		},
 		created(){
 			this.getList();
 		}
	}
</script>

<style lang="less" scoped="scoped">
.cooperation{
	position:relative;
	margin-top: 60px;
	margin-bottom: 70px;
	.NewHand{
		.swiper-wrapper{
			margin-left: 55px;
			img{
				width: 250px;
				height: 300px;
				border: 1px solid red;
				margin-right: 23px;
			}
		}
	}

	.swiper-button-prev{
		left: -50px;
	}
	.swiper-button-next{
		right: -50px;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/pages/ProjectCase/Pcom/Cooperation.vue